document.addEventListener('DOMContentLoaded', () => {
  console.log('component-localization-form.js loaded');

  if (customElements.get('localization-form')) return;

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      console.log('LocalizationForm initialized');

      this.elements = {
        button: this.querySelector('.disclosure__button'),
        panel: this.querySelector('.disclosure__list')
      };

      if (this.elements.button && this.elements.panel) {
        this.init();
      } else {
        console.error('LocalizationForm: Elements not found');
      }
    }

    init() {
      this.elements.button.addEventListener('click', this.togglePanel.bind(this));
      document.addEventListener('click', this.handleOutsideClick.bind(this));
    }

    togglePanel(event) {
      event.stopPropagation();
      console.log('Toggle panel triggered');
      const isHidden = this.elements.panel.classList.contains('is-hidden');
      this.elements.panel.classList.toggle('is-hidden', !isHidden);
      this.elements.button.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
    }

    handleOutsideClick(event) {
      if (!this.contains(event.target)) {
        console.log('Outside click detected');
        this.elements.panel.classList.add('is-hidden');
        this.elements.button.setAttribute('aria-expanded', 'false');
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
});